import { render, staticRenderFns } from "./ProjectPlugins.vue?vue&type=template&id=57b470b3&scoped=true&"
import script from "./ProjectPlugins.vue?vue&type=script&lang=js&"
export * from "./ProjectPlugins.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlugins.vue?vue&type=style&index=0&id=57b470b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b470b3",
  null
  
)

export default component.exports